/* Pass only a checked handle/variant ID. The destination fetches the current product and price. */
(() => {
  if(document.documentElement.dataset.r24BundleSeed)return;
  document.documentElement.dataset.r24BundleSeed='1';
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[data-r24-bundle-seed]');if(!link)return;
    const section=link.closest('[data-purchase-product]'),select=section?.querySelector('#vn-variant'),status=section?.querySelector('[data-r24-bundle-seed-status]');
    let variants;try{variants=JSON.parse(section.querySelector('[data-variants]').textContent);}catch(_){event.preventDefault();return;}
    const variant=variants.find(value=>String(value.id)===select?.value);
    if(!variant?.available){event.preventDefault();if(status){status.hidden=false;status.textContent=window.VenluI18n.t("r24.s_ddc6aed932f0",{},"Choose an available variant for your set first.");}return;}
    if(status)status.hidden=true;
    const url=new URL(link.href,location.origin);url.searchParams.set('set_product',link.dataset.productHandle);url.searchParams.set('set_variant',String(variant.id));link.href=url.href;
  });
})();
